module.exports = __webpack_public_path__ + "static/media/8_FR.50a35f16.mp3";